var map = {
	"./Bronze1.png": 957,
	"./Bronze10.png": 345,
	"./Bronze2.png": 7575,
	"./Bronze3.png": 5757,
	"./Bronze4.png": 7771,
	"./Bronze5.png": 1898,
	"./Bronze6.png": 9035,
	"./Bronze7.png": 5626,
	"./Bronze8.png": 4626,
	"./Bronze9.png": 3087,
	"./Diamond1.png": 7381,
	"./Diamond10.png": 2501,
	"./Diamond2.png": 3489,
	"./Diamond3.png": 1246,
	"./Diamond4.png": 245,
	"./Diamond5.png": 4969,
	"./Diamond6.png": 5425,
	"./Diamond7.png": 3752,
	"./Diamond8.png": 4502,
	"./Diamond9.png": 8150,
	"./Emerald1.png": 1722,
	"./Emerald10.png": 901,
	"./Emerald2.png": 7101,
	"./Emerald3.png": 6708,
	"./Emerald4.png": 2872,
	"./Emerald5.png": 9491,
	"./Emerald6.png": 2934,
	"./Emerald7.png": 9919,
	"./Emerald8.png": 4693,
	"./Emerald9.png": 8822,
	"./Gold1.png": 6365,
	"./Gold10.png": 6248,
	"./Gold2.png": 8619,
	"./Gold3.png": 6097,
	"./Gold4.png": 6175,
	"./Gold5.png": 7487,
	"./Gold6.png": 5966,
	"./Gold7.png": 7261,
	"./Gold8.png": 3123,
	"./Gold9.png": 8629,
	"./Legends1.png": 285,
	"./Legends2.png": 2994,
	"./None.png": 1838,
	"./Ruby1.png": 2158,
	"./Ruby10.png": 6032,
	"./Ruby2.png": 6472,
	"./Ruby3.png": 910,
	"./Ruby4.png": 249,
	"./Ruby5.png": 6870,
	"./Ruby6.png": 6448,
	"./Ruby7.png": 4559,
	"./Ruby8.png": 8131,
	"./Ruby9.png": 6106,
	"./Silver1.png": 657,
	"./Silver10.png": 7026,
	"./Silver2.png": 5814,
	"./Silver3.png": 8850,
	"./Silver4.png": 8055,
	"./Silver5.png": 458,
	"./Silver6.png": 9606,
	"./Silver7.png": 7858,
	"./Silver8.png": 2010,
	"./Silver9.png": 2214
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9393;